import { motion } from "framer-motion";
import { ArrowLeft, Briefcase, Mail } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";

export default function Careers() {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <div className="flex items-center gap-3 mb-6">
            <Briefcase className="w-8 h-8 text-primary" />
            <h1 className="text-3xl font-bold">Careers</h1>
          </div>
          
          <p className="text-muted-foreground mb-8">
            Join us in revolutionizing how businesses do marketing. We're building the future of AI-powered marketing automation.
          </p>
          
          {/* Why Join Us */}
          <Card className="glass-card border-white/10 mb-8">
            <CardContent className="p-6">
              <h2 className="text-xl font-semibold mb-4">Why Join YASNO?</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="text-center p-4">
                  <div className="text-3xl mb-2">🌍</div>
                  <h3 className="font-medium">Remote-First</h3>
                  <p className="text-sm text-muted-foreground">Work from anywhere in the world</p>
                </div>
                <div className="text-center p-4">
                  <div className="text-3xl mb-2">🚀</div>
                  <h3 className="font-medium">Cutting Edge</h3>
                  <p className="text-sm text-muted-foreground">Work with the latest AI technology</p>
                </div>
                <div className="text-center p-4">
                  <div className="text-3xl mb-2">💰</div>
                  <h3 className="font-medium">Competitive Pay</h3>
                  <p className="text-sm text-muted-foreground">Salary + equity compensation</p>
                </div>
              </div>
            </CardContent>
          </Card>
          
          {/* No Current Openings */}
          <h2 className="text-xl font-semibold mb-4">Open Positions</h2>
          <Card className="glass-card border-white/10 mb-8">
            <CardContent className="p-8 text-center">
              <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-white/5 flex items-center justify-center">
                <Briefcase className="w-8 h-8 text-muted-foreground" />
              </div>
              <h3 className="text-lg font-semibold mb-2">No Current Openings</h3>
              <p className="text-muted-foreground max-w-md mx-auto">
                We don't have any open positions at the moment, but we're always growing. 
                Check back soon for future opportunities!
              </p>
            </CardContent>
          </Card>
          
          {/* Stay Connected */}
          <div className="p-6 glass border border-white/10 rounded-xl text-center">
            <h2 className="text-xl font-semibold mb-3">Interested in Future Opportunities?</h2>
            <p className="text-muted-foreground mb-4">
              Send us your resume and we'll reach out when a position that matches your skills becomes available.
            </p>
            <Button 
              variant="outline" 
              onClick={() => window.location.href = 'mailto:careers@yasnomktg.com?subject=Interest in Future Opportunities'}
            >
              <Mail className="w-4 h-4 mr-2" />
              Send Resume
            </Button>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
